module.exports = __webpack_public_path__ + "static/media/29BDOS25.6b41893e.jpg";